import { lazy, Suspense, useMemo, useState } from 'react';
import BugReportContext from './BugReportContext';
import BugReportModal from '@components/BugReportProvider/components/BugReportModal/BugReportModal';
import { HelpCenterProvider } from '@servicetitan/help-center';

const ScreenshotProvider = lazy(
  () => import('@components/ScreenshotProvider/ScreenshotProvider'),
);

interface BugReportProviderProps {
  children: React.ReactNode;
}

export default function BugReportProvider({
  children,
}: BugReportProviderProps) {
  const [showBugReportModal, setShowBugReportModal] = useState(false);

  const value = useMemo(
    () => ({
      createBugReport: () => setShowBugReportModal(true),
    }),
    [setShowBugReportModal],
  );

  return (
    <HelpCenterProvider>
      <BugReportContext.Provider value={value}>
        <Suspense fallback={children}>
          <ScreenshotProvider>
            {children}
            {showBugReportModal && (
              <BugReportModal setOpen={setShowBugReportModal} />
            )}
          </ScreenshotProvider>
        </Suspense>
      </BugReportContext.Provider>
    </HelpCenterProvider>
  );
}
